import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../footer/Footer.component';
import NonAuthHeader from '../header/NonAuthHeader';

const layoutStyle = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
};

const mainStyle = {
  flex: '1 0 auto',
};

const NonAuthLayout = (props) => (
  <div className="app-layout" style={layoutStyle}>
    <NonAuthHeader />
    <div className="nhsuk-width-container-fluid" style={mainStyle}>
      <main className="nhsuk-main-wrapper" id="maincontent" role="main">
        <div className="nhsuk-grid-row">
          <div className="nhsuk-grid-column-full">{props.children}</div>
        </div>
      </main>
    </div>
    <Footer />
  </div>
);

NonAuthLayout.propTypes = {
  children: PropTypes.any,
};

export default NonAuthLayout;
